import React from 'react'
import styled from 'styled-components'
import { media } from '../../assets/js/Helper'
import { vc_base, vc_color } from '../../assets/js/Brand'

// components
import Txt from '../atoms/BaseTxt'
import Anchor from '../atoms/BaseAnchor'

const Pagination = (props) => (
  <PaginationTag>
    <PaginationInner>
      {!props.isFirst && (
        <>
          {props.hasPages && (
            <PaginationItem>
              <PaginationLink to={props.prevPage} rel="prev">
                <Txt type={'span'}>&lt;</Txt>
              </PaginationLink>
            </PaginationItem>
          )}
          <PaginationItem>
            <PaginationLink to={props.prevPage} rel="prev">
              <Txt type={'span'}>{!props.hasPages ? '<' : '1'}</Txt>
            </PaginationLink>
          </PaginationItem>
          {props.hasPages && (
            <PaginationItem>
              <PaginationCurrent>
                <Txt type={'span'}>2</Txt>
              </PaginationCurrent>
            </PaginationItem>
          )}
        </>
      )}
      {!props.hasPages &&
        Array.from({ length: props.numPages }, (_, i) => (
          <PaginationItem key={`pagination-number${i + 1}`}>
            <PaginationLink to={`${props.link}${i === 0 ? '' : i + 1}`}>
              <Txt type={'span'}>{i + 1}</Txt>
            </PaginationLink>
          </PaginationItem>
        ))}
      {!props.isLast && (
        <>
          {props.hasPages && (
            <PaginationItem>
              <PaginationCurrent>
                <Txt type={'span'}>1</Txt>
              </PaginationCurrent>
            </PaginationItem>
          )}
          <PaginationItem>
            <PaginationLink to={props.nextPage} rel="next">
              <Txt type={'span'}>{!props.hasPages ? '>' : '2'}</Txt>
            </PaginationLink>
          </PaginationItem>
          {props.hasPages && (
            <PaginationItem>
              <PaginationLink to={props.nextPage} rel="next">
                <Txt type={'span'}>&gt;</Txt>
              </PaginationLink>
            </PaginationItem>
          )}
        </>
      )}
    </PaginationInner>
  </PaginationTag>
)

export default Pagination

// style
const PaginationTag = styled.div`
  margin-top: ${vc_base.pixel`5`};
  text-align: right;
`
const PaginationInner = styled.ul`
  border: 1px solid ${vc_color.border};
  border-radius: ${vc_base.pixel`0.5`};
  display: inline-flex;
`
const PaginationItem = styled.li`
  border-left: 1px solid ${vc_color.border};
  &:first-child {
    border-left: none;
  }
`
const PaginationCurrent = styled.span`
  background: ${vc_color.primary};
  color: ${vc_color.light};
  display: block;
  padding: 0.5em 1.25em;
`
const PaginationLink = styled(Anchor)`
  display: block;
  padding: 0.5em 1.25em;
  &:not([rel='prev']),
  &:not([rel='next']),
  &:not([aria-current='page']) {
    color: ${vc_color.primary};
    ${media.Large`
			&:hover,
			&:active {
				color: ${vc_color.primary};
			}
		`}
  }
  &[aria-current='page'] {
    background: ${vc_color.primary};
    color: ${vc_color.light};
    ${media.Large`
			&:hover,
			&:active {
				color: ${vc_color.light};
			}
		`}
  }
  &[rel='prev'],
  &[rel='next'] {
    color: ${vc_color.text};
    ${media.Large`
			&:hover,
			&:active {
				color: ${vc_color.text};
			}
		`}
  }
  ${media.Large`
		&:hover:not([aria-current="page"]),
		&:active:not([aria-current="page"]) {
			background: ${vc_color.primary_light};
		}
	`}
`
